export const FOUNDER_QUOTE = {
  text: "\"We used to miss a lot of our leads simply because we were driving or on job sites. Now, 100% of inbound requests are qualified and booked instantly, day or night. It added ~6 signed estimates a week to our calendar.\"",
  name: "Jovan Dedovic",
  role: "Co-founder of ozexteriorsroofinggroup.com",
};
